<template>
  <div class="w-100 h-100 m-0" style="padding: 32px; background: #FFFFFF;">
    <div class="d-flex flex-column" style="gap: 40px;">
      <div class="m-0 p-0 acry-page-title justify-content-center">発行コード履歴</div>
      <!-- パンクズ -->
      <div class="d-flex" style="gap: 14px; font-size: 13px;">
        <div class="c-pointer" style="text-decoration: underline;" @click="onClickReturnTop()" >
          ACRY TICKET TOP
        </div>
        <div>＞</div>
        <div class="c-pointer" style="text-decoration: underline;" @click="onClickReturnList()" >
          チケット一覧
        </div>
        <div>＞</div>
        <div class="c-pointer" style="text-decoration: underline;" @click="onClickReturnEventEdit()" >
          チケット詳細
        </div>
        <div>＞</div>
        <div>発行コード履歴</div>
      </div>

      <!-- <div class="d-flex flex-column">
        <div class="d-flex justify-content-center fw-bold">
          <div class="d-flex cursor-pointer" @click="setShowSample(false)" :style="{background: isShowSample?'#FFFFFF':'#8C9BC6', color: isShowSample?'#8C9BC6':'#FFFFFF'}" style="height: 40px; width: 260px; border: solid 2px #8C9BC6;">
            <div class="m-auto">通常チケット</div>
          </div>
          <div class="d-flex cursor-pointer" @click="setShowSample(true)" :style="{background: isShowSample?'#8C9BC6':'#FFFFFF', color: isShowSample?'#FFFFFF':'#8C9BC6'}" style="height: 40px; width: 260px; border: solid 2px #8C9BC6;">
            <div class="m-auto cursor-pointer">サンプル用チケット</div>
          </div>
        </div>
        <div style="border-bottom: solid 1px #8C9BC6; margin-top: -1px;">
        </div>
      </div> -->


      <TicketCodeLookupForm v-model="ticketSearchCode" @search="executeTicketLookup" />

      <div class="m-0 acrypro-text-main-bold text-start d-flex justify-content-between" style="height: 56px; border-bottom: solid 1px #8C9BC6; padding: 8px 0px;">
        <div>発行コード</div>
        <button class="m-0 acry-btn fw-bold" style="width: 300px; height: 40px; border-radius: 100px; font-size: 16px;" @click="onClickCSV">
            まとめてコードダウンロード
        </button>
      </div>

      <!-- 通常チケットの表示 -->
      <div v-if="!isShowSample" class="w-100 m-0 p-0">
        <div class="w-100 d-flex align-items-center text-start table-header" style="font-size: 13px; gap: 24px;">
          <div style="width: 160px;">発行日</div>
          <div style="width: 160px;">有効期限</div>
          <div style="width: 160px;">発行数</div>
          <div style="width: 160px;">使用数</div>
          <div style="width: 160px;">発行状況</div>
        </div>
        <div v-for="(data, key) in issueDataNormal" :key="key" class="w-100 code-cell d-flex text-start" style="height: 72px; font-size: 15px;" :style="getBgColor(data.validTo)">
          <div class="my-auto" style="width: 184px;">{{formatDate(data.createdAt)}}</div>
          <div class="my-auto d-flex flex-column" style="width: 184px;">
            <div>{{formatDate(data.validFrom)}}〜</div>
            <div>{{formatDate(data.validTo)}}</div>
          </div>
          <div class="my-auto" style="width: 184px;">{{data.requestCount}}</div>
          <div v-if="data.issued" class="my-auto" style="width: 184px;">{{data.usedCount}}</div>
          <div v-if="!data.issued" class="my-auto" style="width: 184px; color: #BC6665;">-</div>
          <div v-if="data.issued" class="my-auto" style="width: 184px;">発行済み</div>
          <div v-if="!data.issued" class="my-auto" style="width: 184px; color: #BC6665;">発行中</div>

          <div class="flex-grow-1"></div>
          <div class="m-auto" style="width: 212px;">
            <button class="m-0 acry-btn fw-bold w-100" style="width: 212px; height: 40px; border-radius: 100px; font-size: 16px;" @click="onClickIssueDetail(data)" :class="{'disable-ui':!data.issued}">
              発行詳細
            </button>
          </div>
        </div>
        <div v-if="issueDataNormal.length == 0" style="margin-top: 16px;">
          まだチケットコードは発行されていません
        </div>
      </div>

      <!-- サンプルチケットの表示 -->
      <div v-if="isShowSample" class="w-100 m-0 p-0">
        <div class="w-100 d-flex align-items-center text-start table-header" style="font-size: 13px; gap: 24px;">
          <div style="width: 160px;">発行日</div>
          <div style="width: 160px;">有効期限</div>
          <div style="width: 160px;">発行数</div>
          <div style="width: 160px;">発行状況</div>
        </div>
        <div v-for="(data, key) in issueDataSample" :key="key" class="w-100 code-cell d-flex text-start" style="height: 72px; font-size: 15px;" :style="getBgColor(data.validTo)">
          <div class="my-auto" style="width: 184px;">{{formatDate(data.createdAt)}}</div>
          <div class="my-auto d-flex flex-column" style="width: 184px;">
            <div>{{formatDate(data.validFrom)}}〜</div>
            <div>{{formatDate(data.validTo)}}</div>
          </div>
          <div class="my-auto" style="width: 184px;">{{data.requestCount}}</div>
          <div v-if="data.issued" class="my-auto" style="width: 184px;">発行済み</div>
          <div v-if="!data.issued" class="my-auto" style="width: 184px; color: #BC6665;">発行中</div>

          <div class="flex-grow-1"></div>
          <div class="m-auto" style="width: 212px;">
            <button class="m-0 acry-btn fw-bold w-100" style="width: 212px; height: 40px; border-radius: 100px; font-size: 16px;" @click="onClickIssueDetail(data)" :class="{'disable-ui':!data.issued}">
              発行詳細
            </button>
          </div>
        </div>
        <div v-if="issueDataSample.length == 0" style="margin-top: 16px;">
          まだチケットコードは発行されていません
        </div>
      </div>

    </div>

    <TicketCodeLookupModal
      :value="ticketModalOpen"
      :result="ticketResult"
      :format-date="formatDate"
      @input="ticketModalOpen = $event"
    />
  </div>
</template>

<script>
import config from "config";
import { CSV } from "@/js/CSV.js";
import { CenterViewState } from "@/js/Const.js";
import ticketCodeLookupMixin from "@/mixins/ticketCodeLookupMixin.js";
import TicketCodeLookupForm from "@/components/acyrpro/ticket/shared/TicketCodeLookupForm.vue";
import TicketCodeLookupModal from "@/components/acyrpro/ticket/shared/TicketCodeLookupModal.vue";

export default {
  name: "CenterViewEventTicketIssueHistory_Ap",
  mixins: [ticketCodeLookupMixin],
  props: {},
  data: function () {
    return {
      issueData:[],
      issueDataNormal:[],
      issueDataSample:[],
      isShowSample: false,
    };
  },
  computed: {

  },
  async created() {
    this.$store.commit("hideRightMenu");
    this.$store.commit("showLoading");

    // 発行情報を取得
    this.issueData = await this.$store.state.acrylicTicketCouponManager.getTicketIssueHistory(
      this.$store.state.acrylicTicketCouponManager.selectEditSetting.docId).catch((e) => {
      this.$handleError("038", e, { hideLoading: true });
    });

    for( let i = 0; i < this.issueData.length; ++i ){
      // 使用数の集計
      let usedCount = 0;
      const codes = await this.$store.state.acrylicTicketCouponManager.getAcryCouponCode(this.issueData[i].acryCouponCodeIssuedHistory);
      codes.forEach(e => {
        if(e.isUsed){
          usedCount++;
        }
      });
      this.issueData[i].usedCount = usedCount;
      if( this.issueData[i].isSample ){
        this.issueDataSample.push(this.issueData[i]);
      }else{
        this.issueDataNormal.push(this.issueData[i]);
      }
    }

    // 通常とサンプルで分ける
    // this.issueData.forEach( (e) => {
    //   if( e.isSample ){
    //     this.issueDataSample.push(e);
    //   }else{
    //     this.issueDataNormal.push(e);
    //   }
    // });

    this.$store.commit("hideLoading");
  },
  components: {
    TicketCodeLookupForm,
    TicketCodeLookupModal,
  },
  methods: {
    setShowSample( isSample ){
      this.isShowSample = isSample;
    },
    onClickReturnTop(){
      this.$store.commit("setCenterViewState", CenterViewState.EventManagement);
    },
    onClickReturnList(){
      this.$store.commit("setCenterViewState", CenterViewState.EventList);
    },
    onClickReturnEventEdit(){
      this.$store.commit("setCenterViewState", CenterViewState.EventEdit);
    },
    onClickIssueDetail(data){
      this.$store.state.acrylicTicketCouponManager.selectTicketIssueData = data;
      this.$store.commit("setCenterViewState", CenterViewState.TicketIssueDetail);
    },
    getBgColor(toDate){
      if( toDate > (new Date()) ){
        return {"background": "#FFFFFF"};
      }else{
        return {"background": "#F8F8F8"};
      }
    },
    async onClickAllCSV(){

    },

    async onClickCSV(){
      const csv = new CSV();
      csv.useHeader = true;
      csv.header = ['コード', 'WEBアクセスURL', '開始日', '終了日', '使用日'];
      let csvData = [];

      const codes = await this.$store.state.acrylicTicketCouponManager.getAllAcryCouponCode(this.$store.state.acrylicTicketCouponManager.selectEditSetting.docId);
      for( const code of codes ){
        csvData.push([code.docId, `${config.ticketWebUrl}/?code=${code.docId}`, this.formatDate(code.validFrom.toDate()), this.formatDate(code.validTo.toDate()), code.usedAt?this.formatDate(code.usedAt.toDate()):""]);
      }
      csv.data = csvData;
      csv.exportData("acryticket_code");
    },

    async onClickReceipt(){

    },

    formatDate(date) {
      const pad = (n) => n.toString().padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.find-input {
  width: 285px;
  height: 48px;
  border: $primary-main-color solid 1px;
  border-radius: 100px;
  background-color: transparent;
  padding: 0px 16px;
}
.table-header{
  width: 800px;
  height: 30px;
  padding: 0px 16px;
  gap: 24px;
  background: #F8F8F8;
  border-bottom: solid 1px #D1D5DB;
}
.code-cell{
  width: 800px;
  height: 120px;
  padding: 16px;
  border-bottom: solid 1px $border-sub-color;
}

.disable-ui{
  cursor: none;
  pointer-events: none;
  opacity: 0.5;
}
</style>
